import Text from '../../../../Text'
import { useCalendarContext } from '../../../Calendar.hooks'
import { getIsCalendarTaskYesNo } from '../../../Calendar.utils'

import { QA_NAME_CALENDAR_ITEM_CARD_STEP } from './CalendarItemCardStep.constants'
import { CalendarItemCardStepDone } from './CalendarItemCardStepDone'
import { CalendarItemCardStepYesNo } from './CalendarItemCardStepYesNo'

import * as styles from './CalendarItemCardStep.module.css'

function CalendarItemCardStep({ step, onClose }) {
  const { onOpenTask } = useCalendarContext()

  function handleClickTitle() {
    onClose()

    onOpenTask(step)
  }

  return (
    <div className={styles.CalendarItemCardStep}>
      {getIsCalendarTaskYesNo(step) ? (
        <CalendarItemCardStepYesNo step={step} />
      ) : (
        <CalendarItemCardStepDone step={step} />
      )}
      <Text
        className={styles.title}
        done={step.isDone}
        qaName={QA_NAME_CALENDAR_ITEM_CARD_STEP}
        onClick={handleClickTitle}
      >
        {step.title}
      </Text>
    </div>
  )
}

export default CalendarItemCardStep
